import {TableCell, TableRow, makeStyles} from '@material-ui/core';
import React from 'react';
import propTypes from 'prop-types';
import PackagesTable from './packages-table';
import {assetsTableStylesObject} from '../../helpers/tools';

const useStyles = makeStyles(() => assetsTableStylesObject);

const DefaultRow = ({data, header, row, asset, isUpdating, packages = [], ruidsToDelete = [], onDeleteDP}) => {
  const classes = useStyles();

  const dataRevised = Array.isArray(data) ? data : [data];
  if (dataRevised?.length && dataRevised[0] !== undefined) {
    return (
      <TableRow className={classes.rowDiv}>
        <h4 className={isUpdating ? classes.rowHeaderDisabled : classes.rowHeader}>{header}</h4>
        {header === 'Data Packages' && packages.length ? (
          <PackagesTable
            asset={asset}
            isUpdating={isUpdating}
            packages={packages}
            ruidsToDelete={ruidsToDelete}
            onDeleteDP={onDeleteDP}
          />
        ) : (
          <TableRow>
            {dataRevised.map((item, index) => {
              if (item && item[row]) {
                return (
                  <TableCell key={index}>
                    <span className={isUpdating ? classes.rowCellDisabled : classes.rowCell}>{item[row]}</span>
                  </TableCell>
                );
              }
              return (
                <TableCell key={index}>
                  <span className={isUpdating ? classes.rowCellDisabled : classes.rowCell}>{item}</span>
                </TableCell>
              );
            })}
            <TableCell />
          </TableRow>
        )}
      </TableRow>
    );
  }
  return null;
};

export default DefaultRow;

DefaultRow.propTypes = {
  asset: propTypes.object,
  data: propTypes.oneOfType([propTypes.array, propTypes.object]),
  header: propTypes.string,
  isUpdating: propTypes.bool,
  onDeleteDP: propTypes.func,
  packages: propTypes.array,
  row: propTypes.string,
  ruidsToDelete: propTypes.array,
};
